import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { InputBaseComponent } from '../input.base';

@Component({
  selector: 'app-input-number-stepper',
  templateUrl: './input-number-stepper.component.html',
  styleUrls: ['./input-number-stepper.component.scss', './../input.base.scss']
})
export class InputNumberStepperComponent extends InputBaseComponent implements OnChanges {
  @Input() public compact = false;
  @Input() public hideLabel = false;
  @Input() public min: number | null = null;
  @Input() public max: number | null = null;
  @Input() public step = 1;
  @Input() public allowDecimals = true;
  @Input() public onlyPositives = false;
  @Input() public readonly: boolean | undefined = undefined;

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.onlyPositives && (this.min === null || this.min === undefined)) {
      this.min = changes.onlyPositives.currentValue ? 0 : null;
    }
  }

  public decrement(): void {
    if (this.isDisabled() || this.isDecrementDisabled()) {
      return;
    }

    const next = this.getCurrentValue() - this.getEffectiveStep();
    this.setValueWithinBounds(next);
  }

  public increment(): void {
    if (this.isDisabled() || this.isIncrementDisabled()) {
      return;
    }

    const next = this.getCurrentValue() + this.getEffectiveStep();
    this.setValueWithinBounds(next);
  }

  public isDecrementDisabled(): boolean {
    if (this.isDisabled()) {
      return true;
    }

    const value = this.getCurrentValue();
    if (this.min === null || this.min === undefined) {
      return false;
    }

    return value <= this.min;
  }

  public isIncrementDisabled(): boolean {
    if (this.isDisabled()) {
      return true;
    }

    const value = this.getCurrentValue();
    if (this.max === null || this.max === undefined) {
      return false;
    }

    return value >= this.max;
  }

  private isDisabled(): boolean {
    return !!this.readonly || this.inputControl?.disabled === true;
  }

  private getCurrentValue(): number {
    const raw = this.inputControl?.value;

    if (raw === null || raw === undefined || raw === '') {
      // start from min if defined, otherwise 0
      if (this.min !== null && this.min !== undefined) {
        return this.min;
      }
      return 0;
    }

    const parsed = Number(raw);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  private getEffectiveStep(): number {
    const step = Number(this.step);
    if (!Number.isFinite(step) || step <= 0) {
      return 1;
    }
    return step;
  }

  private setValueWithinBounds(value: number): void {
    let next = value;

    if (this.min !== null && this.min !== undefined) {
      next = Math.max(next, this.min);
    }

    if (this.max !== null && this.max !== undefined) {
      next = Math.min(next, this.max);
    }

    if (!this.allowDecimals) {
      next = Math.trunc(next);
    }

    this.inputControl.setValue(next);
    this.inputControl.markAsDirty();
    this.inputControl.markAsTouched();
    this.inputControl.updateValueAndValidity();
  }
}
